import * as React from "react";
import SecondaryMenu from "../shared/SecondaryMenu";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import SvgIcon from "@material-ui/core/SvgIcon";
import { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import { useForm, Controller } from "react-hook-form";
import api from "../../store/api";
import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";
import Grid from "@material-ui/core/Grid";
import { TextField, Checkbox, Select, MenuItem } from "@material-ui/core";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import InfoIcon from "@material-ui/icons/Info";
import Button from "@material-ui/core/Button";
import "../../style/UserStyleSheet.css";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DeletePopUp from "../shared/DeletePopUp";
import { consts } from "../../common/consts";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { GridOff } from "@material-ui/icons";
import { format, addDays, isToday, isTomorrow, isYesterday } from "date-fns";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import { time } from "console";
interface AddEditCustomerProps {
  customerId: string | null;
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: 40,
    flexGrow: 1,
  },
  mainTop: {
    //padding: theme.spacing(5, 20, 0, 50)
    //paddingTop: 40,
    //paddingLeft: 40,
  },
  main: {
    //    padding: theme.spacing(0, 20, 0, 50)
    //paddingLeft: 40,
  },
  heading: {
    fontSize: 36,
    fontWeight: 900,
    padding: theme.spacing(0, 0, 2, 0),
  },
  textFieldLable: {
    fontSize: 14,
    fontWeight: 700,
    color: "#949494",
    padding: theme.spacing(0, 0, 1, 0),
  },
  textFieldRoot: {
    width: "100%",
  },
  headingAlert: {
    padding: theme.spacing(0, 0, 2, 0),
  },
  textFieldInput: {
    backgroundColor: "#ECECEC",
    color: "black",
    height: "40px",
  },
  alertRoot: {
    marginTop: 24,
  },
  loading: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  formBtn: {
    margin: theme.spacing(0, 1, 0, 1),
    width: "100px",
    height: "43px",
  },
  testBox: {
    display: "flex",
    alignItems: "center",
    gap: 19,
  },
  testBtn: {
    minWidth: "80px",
    margin: 0,
    height: "39px",
  },
  testMsg: {
    color: "#333333",
    fontSize: 21,
    fontWeight: 400,
  },
  testDateHint: {
    width: 275,
    marginTop: 11,
    color: "#333333",
    fontSize: 14,
    fontWeight: 400,
  },
  formLeft: {
    //   margin: theme.spacing(0, 0, 0, 50)
    paddingLeft: 40,
    paddingBottom: 40,
    paddingTop: 20,
  },
  mainGrid: {
    width: "100%",
    //   padding: theme.spacing(1, 20, 0, 50)
    //paddingLeft: 40,
  },
  removeHover: {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  msspace: {
    marginLeft: "38px",
  },
  dateTimePicker: {
    "& h3": {
      fontSize: "3rem",
    },
    "& h4": {
      fontSize: "2rem",
    },
    "& button": {
      minWidth: 0,
    },
  },
  errorText: {
    fontWeight: 400,
    color: "#f44336",
  },
}));

const ArrowIcon = (props: any) => {
  return (
    <SvgIcon style={{ height: 20, width: 20 }}>
      <path
        d="M6.293,13.707l-6-6L.257,7.67h0L.242,7.652.235,7.644.226,7.634.217,7.622.212,7.615.2,7.6l0,0L.186,7.581l0,0L.172,7.56l0,0L.158,7.54l0,0L.146,7.52l0,0L.134,7.5l0-.005L.122,7.48l0-.008L.112,7.46.106,7.449l0-.009L.094,7.424l0,0L.083,7.4h0a1,1,0,0,1,0-.8v0l.008-.017,0-.009L.1,6.562l.007-.014,0-.006a1,1,0,0,1,.182-.25l6-6A1,1,0,0,1,7.707,1.707L3.414,6H17a1,1,0,0,1,0,2H3.414l4.293,4.293a1,1,0,1,1-1.414,1.414Z"
        fill="#02489D"
      />
    </SvgIcon>
  );
};

const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="10"
      viewBox="0 0 11 10"
      style={{ marginRight: 5 }}
    >
      <path
        id="_copy"
        data-name="* copy"
        d="M7.961,10,9.444,8.9,7.056,5.658,11,4.306,10.276,2.6,6.4,4.021V0H4.487V4.021L.651,2.6,0,4.306,3.836,5.658,1.484,8.9,3.112,10,5.464,6.584Z"
        fill="#f4b827"
      />
    </svg>
  );
};

const CreateLoadingLine = (props: any): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.loading}>
      <LinearProgress color="primary" />
    </div>
  );
};

const HorizontalLine = (props: any) => {
  return (
    <hr
      style={{
        ...props,
        height: 0,
        borderTop: "1px solid #979797",
      }}
    />
  );
};

function AddEditCustomerWidget(props: AddEditCustomerProps): JSX.Element {
  //States and Variables
  const history = useHistory();
  const classes = useStyles();
  const customerId = props.customerId;
  const [editCustomerId, setEditCustomerId] = useState(customerId);
  const {
    handleSubmit,
    watch,
    errors,
    control,
    formState,
    setValue,
    getValues,
    setError,
    trigger,
  } = useForm();
  const [headingText, setHeadingText] = useState("Customers");
  const [mainHeadingText, setMainHeadingText] = useState(
    customerId ? "Edit Customer" : "New Customer"
  );
  const [editCustomer, setEditCustomer] = useState(customerId ? true : false);
  const [errorMessage, setErrorMessage] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isEnabled, setIsEnabled] = useState(true);
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [testMessage, setTestMessage] = useState("");
  const [errorMessageBilling, seterrorMessageBilling] = useState("");
  const [sections, setSections] = useState({
    code1enable: false,
    code2enable: false,
    code3enable: false,
    code4enable: false,
  });
  const isNumber = (value: string) => /^\d+$/.test(value);
  const handleCheckboxChange = (section: any) => (event: any) => {
    setSections((prevSections) => ({
      ...prevSections,
      [section]: event.target.checked,
    }));
  };
  //Functions and API calls
  React.useEffect(() => {
    setValue("autopriceunavailbefore", null);
    setValue("commencementDate", null);
    if (customerId) getEditCustomerData();
  }, []);

  const deleteCustomer = async (): Promise<void> => {
    setLoading(true);
    let values = getValues();
    let _req: { [index: string]: any } = {
      customerId: editCustomerId,
      name: values["name"],
      isEnabled: isEnabled,
      deleted: true,
    };

    await api
      .updateCustomer("", _req)
      .then((res) => {
        if (!res.hasError && res.message !== null) {
          resetMessages();
          backToCustomerList();
          setStatusMessage(res.message);
        } else {
          resetMessages();
          setErrorMessage(res.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        setErrorMessage(error);
        setLoading(false);
      });
  };

  const updateCustomer = async (): Promise<void> => {
    setLoading(true);
    setStatusMessage("");
    setErrorMessage("");
    let values = getValues();
    let hasErrorForCode: any[] = [];
    var code1AcceptableValue = sections.code1enable
      ? values["code1Acceptable"]
      : "";
    if (!IsNullOrEmpty(code1AcceptableValue)) {
      var code1AcceptableValuearray = splitByCommaToArray(code1AcceptableValue);
      var code1HasError = setErrorWhenLengthExceed(
        "code1Acceptable",
        code1AcceptableValuearray
      );
      hasErrorForCode.push(code1HasError);
    }
    var code2AcceptableValue = sections.code2enable
      ? values["code2Acceptable"]
      : "";
    if (!IsNullOrEmpty(code2AcceptableValue)) {
      var code2AcceptableValuearray = splitByCommaToArray(code2AcceptableValue);
      var code2HasError = setErrorWhenLengthExceed(
        "code2Acceptable",
        code2AcceptableValuearray
      );
      hasErrorForCode.push(code2HasError);
    }
    var code3AcceptableValue = sections.code3enable
      ? values["code3Acceptable"]
      : "";
    if (!IsNullOrEmpty(code3AcceptableValue)) {
      var code3AcceptableValuearray = splitByCommaToArray(code3AcceptableValue);
      var code3HasError = setErrorWhenLengthExceed(
        "code3Acceptable",
        code3AcceptableValuearray
      );
      hasErrorForCode.push(code3HasError);
    }
    var code4AcceptableValue = sections.code4enable
      ? values["code4Acceptable"]
      : "";
    if (!IsNullOrEmpty(code4AcceptableValue)) {
      var code4AcceptableValuearray = splitByCommaToArray(code4AcceptableValue);
      var code4HasError = setErrorWhenLengthExceed(
        "code4Acceptable",
        code4AcceptableValuearray
      );
      hasErrorForCode.push(code4HasError);
    }
    if (!hasErrorForCode.includes(true)) {
      let _req: { [index: string]: any } = {
        customerId: editCustomerId,
        name: values["name"],
        isEnabled: isEnabled,
        code1Label: sections.code1enable ? values["code1Label"] : "",
        code1AcceptableValues: sections.code1enable
          ? values["code1Acceptable"]
          : "",
        code2Label: sections.code2enable ? values["code2Label"] : "",
        code2AcceptableValues: sections.code2enable
          ? values["code2Acceptable"]
          : "",
        code3Label: sections.code3enable ? values["code3Label"] : "",
        code3AcceptableValues: sections.code3enable
          ? values["code3Acceptable"]
          : "",
        code4Label: sections.code4enable ? values["code4Label"] : "",
        code4AcceptableValues: sections.code4enable
          ? values["code4Acceptable"]
          : "",
        billingRuleID: values["rule"],
        billingRuleVersion:
          values["version"] != "" && values["version"] != null
            ? Number(values["version"])
            : null,
        automatedPricingUnavailableBefore:
          values["autopriceunavailbefore"] != null
            ? format(new Date(values["autopriceunavailbefore"]), "yyyy-MM-dd")
            : null,
        commencementDate:
          values["commencementDate"] != null
            ? format(new Date(values["commencementDate"]), "yyyy-MM-dd")
            : null,
        billingFrequency:
          values["billingFrequency"] == 0 ? null : values["billingFrequency"],
        contractedEntity:
          values["contractedEntity"] == 0 ? null : values["contractedEntity"],
      };

      await api
        .updateCustomer("", _req)
        .then((res) => {
          if (!res.hasError && res.message !== null) {
            resetMessages();
            setHeadingText(getValues("name"));
            setStatusMessage(res.message);
          } else {
            resetMessages();
            setErrorMessage(res.message);
          }
          setLoading(false);
        })
        .catch((error) => {
          setErrorMessage(error);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  const IsNullOrEmpty = (Value: any) => {
    if (Value != null && Value != "" && Value != undefined && Value.length > 0)
      return false;
    else return true;
  };

  const getEditCustomerData = async (): Promise<void> => {
    setLoading(true);
    setStatusMessage("");
    setErrorMessage("");

    try {
      const _res = await api.getEditCustomerdData(
        "customerId=" + editCustomerId
      );
      if (_res !== null && _res.data !== null && _res.data.model !== null) {
        setHeadingText(_res.data.model.name);
        setValue("name", _res.data.model.name);
        setIsEnabled(_res.data.model.isEnabled);
        setValue("code1Label", _res?.data?.model?.code1Label);
        setValue("code1Acceptable", _res?.data?.model?.code1AcceptableValues);
        setValue("code2Label", _res?.data?.model?.code2Label);
        setValue("code2Acceptable", _res?.data?.model?.code2AcceptableValues);
        setValue("code3Label", _res?.data?.model?.code3Label);
        setValue("code3Acceptable", _res?.data?.model?.code3AcceptableValues);
        setValue("code4Label", _res?.data?.model?.code4Label);
        setValue("code4Acceptable", _res?.data?.model?.code4AcceptableValues);
        setValue("rule", _res?.data?.model?.billingRuleID);
        setValue("version", _res?.data?.model?.billingRuleVersion);
        setValue(
          "autopriceunavailbefore",
          _res?.data?.model?.automatedPricingUnavailableBefore != null
            ? _res?.data?.model?.automatedPricingUnavailableBefore
            : null
        );
        setValue(
          "commencementDate",
          _res?.data?.model?.commencementDate != null
            ? _res?.data?.model?.commencementDate
            : null
        );
        setValue(
          "billingFrequency",
          _res?.data?.model?.billingFrequency == null
            ? 0
            : _res?.data?.model?.billingFrequency
        );
        setValue(
          "contractedEntity",
          _res?.data?.model?.contractedEntity == null
            ? 0
            : _res?.data?.model?.contractedEntity
        );
        setSections({
          code1enable:
            !IsNullOrEmpty(_res?.data?.model?.code1Label) ||
            !IsNullOrEmpty(_res?.data?.model?.code1AcceptableValues)
              ? true
              : false,
          code2enable:
            !IsNullOrEmpty(_res?.data?.model?.code2Label) ||
            !IsNullOrEmpty(_res?.data?.model?.code2AcceptableValues)
              ? true
              : false,
          code3enable:
            !IsNullOrEmpty(_res?.data?.model?.code3Label) ||
            !IsNullOrEmpty(_res?.data?.model?.code3AcceptableValues)
              ? true
              : false,
          code4enable:
            !IsNullOrEmpty(_res?.data?.model?.code4Label) ||
            !IsNullOrEmpty(_res?.data?.model?.code4AcceptableValues)
              ? true
              : false,
        });
      }
      setLoading(false);
      resetMessages();
    } catch (err) {
      setErrorMessage("Error has happened while getting customer");
      setLoading(false);
    }
  };

  const splitByCommaToArray = (value: any) => {
    if (!IsNullOrEmpty(value)) {
      const initialString = value;
      const initialArray = initialString?.split(",");
      const cleanedArray = initialArray?.map((val: any) =>
        val.replace(/"/g, "")
      );
      return cleanedArray;
    } else {
      return null;
    }
  };

  const setErrorWhenLengthExceed = (
    codeName: string,
    acceptableValueArray: any[]
  ) => {
    if (
      acceptableValueArray.length > 0 &&
      !IsNullOrEmpty(acceptableValueArray)
    ) {
      let visibleError: boolean = false;
      // Use some method to iterate over the array
      visibleError = acceptableValueArray.some(
        (element) => element.length > 100
      );

      if (visibleError) {
        setError(codeName, {
          type: "manual",
          message: "Individual code cannot exceed 100 characters",
        });
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const addNewCustomer = async (): Promise<void> => {
    setLoading(true);
    setStatusMessage("");
    setErrorMessage("");
    let values = getValues();
    let hasErrorForCode: any[] = [];
    var code1AcceptableValue = sections.code1enable
      ? values["code1Acceptable"]
      : "";
    if (!IsNullOrEmpty(code1AcceptableValue)) {
      var code1AcceptableValuearray = splitByCommaToArray(code1AcceptableValue);
      var code1HasError = setErrorWhenLengthExceed(
        "code1Acceptable",
        code1AcceptableValuearray
      );
      hasErrorForCode.push(code1HasError);
    }
    var code2AcceptableValue = sections.code2enable
      ? values["code2Acceptable"]
      : "";
    if (!IsNullOrEmpty(code2AcceptableValue)) {
      var code2AcceptableValuearray = splitByCommaToArray(code2AcceptableValue);
      var code2HasError = setErrorWhenLengthExceed(
        "code2Acceptable",
        code2AcceptableValuearray
      );
      hasErrorForCode.push(code2HasError);
    }
    var code3AcceptableValue = sections.code3enable
      ? values["code3Acceptable"]
      : "";
    if (!IsNullOrEmpty(code3AcceptableValue)) {
      var code3AcceptableValuearray = splitByCommaToArray(code3AcceptableValue);
      var code3HasError = setErrorWhenLengthExceed(
        "code3Acceptable",
        code3AcceptableValuearray
      );
      hasErrorForCode.push(code3HasError);
    }
    var code4AcceptableValue = sections.code4enable
      ? values["code4Acceptable"]
      : "";
    if (!IsNullOrEmpty(code4AcceptableValue)) {
      var code4AcceptableValuearray = splitByCommaToArray(code4AcceptableValue);
      var code4HasError = setErrorWhenLengthExceed(
        "code4Acceptable",
        code4AcceptableValuearray
      );
      hasErrorForCode.push(code4HasError);
    }
    if (!hasErrorForCode.includes(true)) {
      let _req: { [index: string]: any } = {
        name: values["name"],
        isEnabled: isEnabled,
        code1Label: sections.code1enable ? values["code1Label"] : "",
        code1AcceptableValues: sections.code1enable
          ? values["code1Acceptable"]
          : "",
        code2Label: sections.code2enable ? values["code2Label"] : "",
        code2AcceptableValues: sections.code2enable
          ? values["code2Acceptable"]
          : "",
        code3Label: sections.code3enable ? values["code3Label"] : "",
        code3AcceptableValues: sections.code3enable
          ? values["code3Acceptable"]
          : "",
        code4Label: sections.code4enable ? values["code4Label"] : "",
        code4AcceptableValues: sections.code4enable
          ? values["code4Acceptable"]
          : "",
        billingRuleID: values["rule"],
        billingRuleVersion:
          values["version"] != "" && values["version"] != null
            ? values["version"]
            : null,
        automatedPricingUnavailableBefore:
          values["autopriceunavailbefore"] != null
            ? format(new Date(values["autopriceunavailbefore"]), "yyyy-MM-dd")
            : null,
        commencementDate:
          values["commencementDate"] != null
            ? format(new Date(values["commencementDate"]), "yyyy-MM-dd")
            : null,
        billingFrequency:
          values["billingFrequency"] == 0 ? null : values["billingFrequency"],
        contractedEntity:
          values["contractedEntity"] == 0 ? null : values["contractedEntity"],
      };

      await api
        .addNewCustomer("", _req)
        .then((res) => {
          if (!res.hasError && res.message !== null) {
            resetMessages();
            setStatusMessage(res.message);
            backToCustomerList();
          } else {
            resetMessages();
            setErrorMessage(res.message ?? "");
          }
          setLoading(false);
        })
        .catch((error) => {
          setErrorMessage(error);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  const backToCustomerList = () => {
    history.push({
      pathname: "/settings/customers",
    });
  };
  const resetMessages = () => {
    setErrorMessage("");
    setStatusMessage("");
  };

  const handleTest = () => {
    setLoading(true);
    var values = getValues();
    setTestMessage("");
    if (values["rule"] === null || values["rule"] === "") {
      seterrorMessageBilling("Billing Rule  cannot be empty");
      setLoading(false);
      return;
    } else {
      seterrorMessageBilling("");
    }
    if (values["rule"] !== "") {
      if (values["rule"]?.trim() === "") {
        seterrorMessageBilling("Billing Rule cannot be empty");
        setLoading(false);
        return;
      }
    }
    if (values["rule"] !== "") {
      const res = api.checkRules(
        "ruleName=" + values["rule"] + "&version=" + values["version"]
      );
      res.then((res) => {
        if (res.hasError) {
          setTestMessage("Test not Succeeded");
          setLoading(false);
        } else {
          setTestMessage("Test Succeeded");
          setLoading(false);
        }
      });
    }
  };
  const billingfrequency = [
    {
      id: 0,
      text: "Choose",
      selected: true,
    },
    {
      id: 1,
      text: "Weekly",
      selected: false,
    },
    {
      id: 2,
      text: "Fortnightly",
      selected: false,
    },
    {
      id: 3,
      text: "Monthly",
      selected: false,
    },
    {
      id: 4,
      text: "Quarterly",
      selected: false,
    },
    {
      id: 5,
      text: "Bi-annually",
      selected: false,
    },
    {
      id: 6,
      text: "Annually",
      selected: false,
    },
  ];
  const contractedentity = [
    {
      id: 0,
      text: "Choose",
      selected: true,
    },
    {
      id: 1,
      text: "Customer",
      selected: false,
    },
    {
      id: 2,
      text: "Location",
      selected: false,
    },
  ];

  return (
    <>
      <div style={{ display: "flex", alignItems: "stretch", flexGrow: 1 }}>
        <div style={{ alignSelf: "stretch", display: "flex" }}>
          <SecondaryMenu selectedmenu="Customers" />
        </div>

        <form
          style={{ width: "100%" }}
          onSubmit={handleSubmit(
            editCustomer ? updateCustomer : addNewCustomer
          )}
          autoComplete="off"
          id="addCustomerForm"
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div style={{ padding: 40 }}>
              <Grid className={classes.mainGrid} container spacing={3}>
                <Grid item xs={12}>
                  <div className={classes.mainTop}>
                    <IconButton
                      className={classes.removeHover}
                      onClick={backToCustomerList}
                      aria-label="delete"
                      size="small"
                    >
                      <ArrowIcon />
                      <span className="backBtn">{headingText}</span>
                    </IconButton>
                    {editCustomer ? (
                      <Button
                        className="changePasswordBtn"
                        variant="contained"
                        onClick={() => setConfirmationDialog(true)}
                      >
                        Delete
                      </Button>
                    ) : null}
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div className={classes.main}>
                    <div className={classes.heading}>{mainHeadingText}</div>
                  </div>
                </Grid>

                <Grid item xs={4}>
                  <div className={classes.textFieldLable}>
                    <span>
                      <StarIcon />
                    </span>
                    NAME
                  </div>
                  <Controller
                    control={control}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        InputProps={{
                          classes: { root: classes.textFieldInput },
                        }}
                        variant="outlined"
                        error={errors.name}
                        helperText={errors.name ? errors.name.message : ""}
                      />
                    }
                    name="name"
                    defaultValue=""
                    rules={{
                      required: "Name is required",
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <div className={classes.textFieldLable}>
                    <span>
                      <StarIcon />
                    </span>
                    STATUS
                  </div>
                  <Controller
                    render={(props) => (
                      <RadioGroup
                        row
                        aria-label="position"
                        name="Status"
                        defaultValue="top"
                      >
                        <FormControlLabel
                          value="Enabled"
                          checked={isEnabled}
                          onChange={(e) => {
                            props.onChange(e);
                            setIsEnabled(true);
                          }}
                          control={<Radio color="primary" />}
                          label="Enabled"
                        />
                        <FormControlLabel
                          value="Disabled"
                          checked={!isEnabled}
                          onChange={(e) => {
                            props.onChange(e);
                            setIsEnabled(false);
                          }}
                          control={<Radio color="primary" />}
                          label="Disabled"
                        />
                      </RadioGroup>
                    )}
                    name="Status"
                    defaultValue=""
                    control={control}
                  />
                </Grid>

                <Grid item xs={12}>
                  <HorizontalLine opacity={0.39} />
                </Grid>

                <Grid item xs={12}>
                  <div className={classes.textFieldLable}>LOCATION CODES</div>
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sections.code1enable}
                        onChange={handleCheckboxChange("code1enable")}
                        color="primary"
                      />
                    }
                    label="Code 1 Enabled"
                  />
                </Grid>
                <Grid item xs={4} className={classes.msspace}>
                  <div className={classes.textFieldLable}>LABEL</div>
                  <Controller
                    control={control}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        inputProps={{ maxLength: 50 }}
                        variant="outlined"
                        disabled={!sections.code1enable}
                        placeholder="Location Code 1"
                        error={errors.code1Label}
                        helperText={
                          errors.code1Label ? errors.code1Label.message : ""
                        }
                      />
                    }
                    name="code1Label"
                    variant="outlined"
                    defaultValue=""
                    rules={{
                      pattern: {
                        value: consts.LocationcodeLabelRegex,
                        message: "Invalid Code 1 Label",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.textFieldLable}>
                    ACCEPTABLE VALUES
                  </div>
                  <Controller
                    control={control}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        variant="outlined"
                        disabled={!sections.code1enable}
                        placeholder='Eg. "Yes", "No"'
                        error={errors.code1Acceptable}
                        helperText={
                          errors.code1Acceptable
                            ? errors.code1Acceptable.message
                            : ""
                        }
                      />
                    }
                    name="code1Acceptable"
                    defaultValue=""
                    rules={{
                      pattern: {
                        value: consts.LocationcodeAcceptableValueRegex,
                        message: "Invalid Code 1 Acceptable Value",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sections.code2enable}
                        onChange={handleCheckboxChange("code2enable")}
                        color="primary"
                      />
                    }
                    label="Code 2 Enabled"
                  />
                </Grid>
                <Grid item xs={4} className={classes.msspace}>
                  <div className={classes.textFieldLable}>LABEL</div>
                  <Controller
                    control={control}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        inputProps={{ maxLength: 50 }}
                        variant="outlined"
                        disabled={!sections.code2enable}
                        placeholder="Location Code 2"
                        error={errors.code2Label}
                        helperText={
                          errors.code2Label ? errors.code2Label.message : ""
                        }
                      />
                    }
                    name="code2Label"
                    defaultValue=""
                    rules={{
                      pattern: {
                        value: consts.LocationcodeLabelRegex,
                        message: "Invalid Code 2 Label",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.textFieldLable}>
                    ACCEPTABLE VALUES
                  </div>
                  <Controller
                    control={control}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        variant="outlined"
                        disabled={!sections.code2enable}
                        placeholder='Eg. "Yes", "No"'
                        error={errors.code2Acceptable}
                        helperText={
                          errors.code2Acceptable
                            ? errors.code2Acceptable.message
                            : ""
                        }
                      />
                    }
                    name="code2Acceptable"
                    defaultValue=""
                    rules={{
                      pattern: {
                        value: consts.LocationcodeAcceptableValueRegex,
                        message: "Invalid Code 2 Acceptable Value",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sections.code3enable}
                        onChange={handleCheckboxChange("code3enable")}
                        color="primary"
                      />
                    }
                    label="Code 3 Enabled"
                  />
                </Grid>
                <Grid item xs={4} className={classes.msspace}>
                  <div className={classes.textFieldLable}>LABEL</div>
                  <Controller
                    control={control}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        inputProps={{ maxLength: 50 }}
                        variant="outlined"
                        disabled={!sections.code3enable}
                        placeholder="Location Code 3"
                        error={errors.code3Label}
                        helperText={
                          errors.code3Label ? errors.code3Label.message : ""
                        }
                      />
                    }
                    name="code3Label"
                    defaultValue=""
                    rules={{
                      pattern: {
                        value: consts.LocationcodeLabelRegex,
                        message: "Invalid Code 3 Label",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.textFieldLable}>
                    ACCEPTABLE VALUES
                  </div>
                  <Controller
                    control={control}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        variant="outlined"
                        disabled={!sections.code3enable}
                        placeholder='Eg. "Yes", "No"'
                        error={errors.code3Acceptable}
                        helperText={
                          errors.code3Acceptable
                            ? errors.code3Acceptable.message
                            : ""
                        }
                      />
                    }
                    name="code3Acceptable"
                    defaultValue=""
                    rules={{
                      pattern: {
                        value: consts.LocationcodeAcceptableValueRegex,
                        message: "Invalid Code 3 Acceptable Value",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={sections.code4enable}
                        onChange={handleCheckboxChange("code4enable")}
                        color="primary"
                      />
                    }
                    label="Code 4 Enabled"
                  />
                </Grid>
                <Grid item xs={4} className={classes.msspace}>
                  <div className={classes.textFieldLable}>LABEL</div>
                  <Controller
                    control={control}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        inputProps={{ maxLength: 50 }}
                        variant="outlined"
                        disabled={!sections.code4enable}
                        placeholder="Location Code 4"
                        error={errors.code4Label}
                        helperText={
                          errors.code4Label ? errors.code4Label.message : ""
                        }
                      />
                    }
                    name="code4Label"
                    defaultValue=""
                    rules={{
                      pattern: {
                        value: consts.LocationcodeLabelRegex,
                        message: "Invalid Code 4 Label",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.textFieldLable}>
                    ACCEPTABLE VALUES
                  </div>
                  <Controller
                    control={control}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        variant="outlined"
                        disabled={!sections.code4enable}
                        placeholder='Eg. "Yes", "No"'
                        error={errors.code4Acceptable}
                        helperText={
                          errors.code4Acceptable
                            ? errors.code4Acceptable.message
                            : ""
                        }
                      />
                    }
                    name="code4Acceptable"
                    defaultValue=""
                    rules={{
                      pattern: {
                        value: consts.LocationcodeAcceptableValueRegex,
                        message: "Invalid Code 4 Acceptable Value",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <HorizontalLine opacity={0.39} />
                </Grid>
                {/* <Grid item xs={12}>                                 */}
                <Grid item xs={3}>
                  <div className={classes.textFieldLable}>
                    COMMENCEMENT DATE
                  </div>
                  <Controller
                    control={control}
                    render={({ name, value, onChange }) => (
                      <div>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            InputProps={{
                              classes: { root: classes.textFieldInput },
                            }}
                            format="dd/MM/yyyy"
                            placeholder="dd/mm/yyyy"
                            inputVariant="outlined"
                            initialFocusedDate={null}
                            invalidDateMessage="Invalid Date"
                            value={value}
                            onChange={(date, value) => {
                              onChange(date);
                            }}
                            DialogProps={{
                              className: classes.dateTimePicker,
                            }}
                            style={{ width: 210 }}
                          />
                        </MuiPickersUtilsProvider>
                        {errors.commencementDate && (
                          <p className={classes.errorText}>
                            {errors.commencementDate.message}
                          </p>
                        )}
                      </div>
                    )}
                    name="commencementDate"
                    defaultValue=""
                    rules={{
                      validate: () => {
                        const allValues = getValues();
                        const commencementDate = allValues["commencementDate"];
                        const billingFrequency = allValues["billingFrequency"];
                        if (
                          commencementDate == null &&
                          billingFrequency != 0 &&
                          billingFrequency != null
                        ) {
                          return "Commencement date is required";
                        }
                        return true;
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <div className={classes.textFieldLable}>
                    BILLING FREQUENCY
                  </div>
                  <Controller
                    control={control}
                    render={({ name, value, onChange }) => (
                      <div>
                        <Select
                          classes={{ root: classes.textFieldRoot }}
                          style={{ width: "100%" }}
                          IconComponent={KeyboardArrowDownIcon}
                          variant="outlined"
                          displayEmpty
                          value={value}
                          onChange={(e) => {
                            onChange(e.target.value);
                            if (e.target.value == 0) {
                              trigger("commencementDate");
                            }
                          }}
                        >
                          {billingfrequency.map((item) => (
                            <MenuItem
                              selected={item.selected}
                              key={item.id}
                              defaultValue={item.id}
                              value={item.id}
                            >
                              {item.text}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.billingFrequency && (
                          <p className={classes.errorText}>
                            {errors.billingFrequency.message}
                          </p>
                        )}
                      </div>
                    )}
                    error={errors.billingFrequency}
                    helperText={
                      errors.billingFrequency
                        ? errors.billingFrequency.message
                        : ""
                    }
                    name="billingFrequency"
                    defaultValue={0}
                  />
                </Grid>
                {/* </Grid> */}
                <Grid item xs={12} style={{ padding: 0 }}></Grid>
                <Grid item xs={3}>
                  <div className={classes.textFieldLable}>BILLING RULE</div>
                  <Controller
                    control={control}
                    render={({ onChange, onBlur, value }) => (
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        InputProps={{
                          classes: { root: classes.textFieldInput },
                        }}
                        variant="outlined"
                        error={errors.rule}
                        helperText={errors.rule ? errors.rule.message : ""}
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                          if (e.target.value === "") {
                            trigger("contractedEntity");
                          }
                        }}
                      />
                    )}
                    name="rule"
                    defaultValue=""
                    // rules={{
                    //     required: "Billing Rule is required"
                    // }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <div className={classes.textFieldLable}>VERSION</div>
                  <Controller
                    control={control}
                    as={
                      <TextField
                        classes={{ root: classes.textFieldRoot }}
                        InputProps={{
                          classes: { root: classes.textFieldInput }
                        }}
                        variant="outlined"
                        error={errors.version}
                        helperText={
                          errors.version ? errors.version.message : ""
                        }
                        placeholder="Latest"
                      />
                    }
                    name="version"
                    defaultValue=""
                    rules={{
                      validate: {
                        isNumeric: value => !value || isNumber(value) || "Version is not a valid number"
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={7}>
                  <div className={classes.textFieldLable}>&nbsp;</div>
                  <div className={classes.testBox}>
                    <Button
                      type="button"
                      onClick={handleTest}
                      disabled={formState.isSubmitting}
                      className={classes.testBtn}
                      variant="contained"
                      color="primary"
                    >
                      Test
                    </Button>
                    {testMessage && (
                      <div className={classes.testMsg}>{testMessage}</div>
                    )}
                    {errorMessageBilling && (
                      <div className={classes.testMsg} style={{ color: "red" }}>
                        {errorMessageBilling !== "null"
                          ? errorMessageBilling
                          : ""}
                      </div>
                    )}
                  </div>
                </Grid>
                <Grid item xs={4} xl={3}>
                  <div className={classes.textFieldLable}>
                    AUTOMATED PRICING UNAVAILABLE BEFORE..
                  </div>
                  <Controller
                    control={control}
                    render={({ name, value, onChange }) => (
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          InputProps={{
                            classes: { root: classes.textFieldInput },
                          }}
                          format="dd/MM/yyyy"
                          placeholder="dd/mm/yyyy"
                          inputVariant="outlined"
                          initialFocusedDate={null}
                          invalidDateMessage="Invalid Date"
                          value={value}
                          onChange={(date, value) => {
                            onChange(date);
                          }}
                          DialogProps={{
                            className: classes.dateTimePicker,
                          }}
                          style={{ width: 210 }}
                        />
                      </MuiPickersUtilsProvider>
                    )}
                    name="autopriceunavailbefore"
                    defaultValue=""
                  />
                  <div className={classes.testDateHint}>
                    Complete this field if transfers prior to a certain date
                    don’t contain enough data to be priced automatically
                  </div>
                </Grid>
                <Grid item xs={2} xl={2}>
                  <div className={classes.textFieldLable}>
                    CONTRACTED ENTITY
                  </div>
                  <Controller
                    control={control}
                    render={({ name, value, onChange }) => (
                      <div>
                        <Select
                          classes={{ root: classes.textFieldRoot }}
                          style={{ width: "100%" }}
                          IconComponent={KeyboardArrowDownIcon}
                          variant="outlined"
                          displayEmpty
                          value={value}
                          onChange={(e) => {
                            onChange(e.target.value);
                          }}
                        >
                          {contractedentity.map((item) => (
                            <MenuItem
                              selected={item.selected}
                              key={item.id}
                              defaultValue={item.id}
                              value={item.id}
                            >
                              {item.text}
                            </MenuItem>
                          ))}
                        </Select>
                        {errors.contractedEntity && (
                          <p className={classes.errorText}>
                            {errors.contractedEntity.message}
                          </p>
                        )}
                      </div>
                    )}
                    name="contractedEntity"
                    defaultValue={null}
                    rules={{
                      validate: () => {
                        const allValues = getValues();
                        const contractedEntity = allValues["contractedEntity"];
                        const rule = allValues["rule"];
                        if (
                          rule != null &&
                          rule != "" &&
                          (contractedEntity === 0 || contractedEntity == null)
                        ) {
                          return "Contracted entity is required";
                        }
                        return true;
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </div>
            <div>
              <div
                className={classes.main}
                style={{ paddingLeft: 40, paddingRight: 40 }}
              >
                <div className={classes.headingAlert}>
                  <Alert
                    variant="filled"
                    icon={<ReportProblemOutlinedIcon />}
                    severity="error"
                    classes={{ root: classes.alertRoot }}
                    style={{ display: errorMessage ? "flex" : "none" }}
                  >
                    {errorMessage}
                  </Alert>
                  <Alert
                    variant="filled"
                    icon={<InfoIcon />}
                    severity="success"
                    classes={{ root: classes.alertRoot }}
                    style={{ display: statusMessage ? "flex" : "none" }}
                  >
                    {statusMessage}
                  </Alert>
                </div>
              </div>
              <div style={{ paddingTop: 0, paddingBottom: 20 }}>
                {loading ? <CreateLoadingLine /> : <HorizontalLine />}
              </div>
              <div className={classes.formLeft}>
                <Button
                  disabled={formState.isSubmitting}
                  className={classes.formBtn}
                  variant="contained"
                  color="primary"
                  type="submit"
                >
                  Save
                </Button>
                <Button
                  className={classes.formBtn}
                  variant="contained"
                  onClick={backToCustomerList}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <DeletePopUp
        isDialogOpen={confirmationDialog}
        onCancel={() => setConfirmationDialog(false)}
        onDo={deleteCustomer}
        title="Delete customer"
        recordName="customer"
      />
    </>
  );
}

export default React.memo(AddEditCustomerWidget);
